import { Component, Input, OnInit } from '@angular/core';
import { interval } from 'rxjs';

@Component({
  selector: 'app-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.scss']
})
export class CenterComponent implements OnInit {

  @Input() view;

  pointer: any;
  subscription: any;

  constructor() { }

  ngOnInit(): void {
    this.subscription = interval(200)
      .subscribe(() => {
        if (!this.view) {
          return;
        }

        this.pointer = {
          yaw: this.view.yaw() / (Math.PI/180),
          pitch: this.view.pitch() / (Math.PI/180),
          fov: this.view.fov() / (Math.PI/180),
        };
      });
  }
}
